function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.1594 2.34054C11.0387 -0.780201 5.9613 -0.780201 2.84056 2.34054C-0.280186 5.46128 -0.280186 10.5387 2.84056 13.6594C5.9613 16.7802 11.0387 16.7802 14.1594 13.6594C17.2802 10.5387 17.2802 5.46128 14.1594 2.34054ZM10.5044 10.9476L8.5 8.94317L6.49559 10.9476C6.23522 11.2079 5.81277 11.2079 5.5524 10.9476C5.29204 10.6872 5.29204 10.2648 5.5524 10.0044L7.55682 7.99998L5.5524 5.99557C5.29204 5.73521 5.29204 5.31275 5.5524 5.05239C5.81277 4.79202 6.23522 4.79202 6.49559 5.05239L8.5 7.0568L10.5044 5.05239C10.7648 4.79202 11.1872 4.79202 11.4476 5.05239C11.708 5.31275 11.708 5.73521 11.4476 5.99557L9.44318 7.99998L11.4476 10.0044C11.708 10.2648 11.708 10.6872 11.4476 10.9476C11.1872 11.2079 10.7648 11.2079 10.5044 10.9476Z",
  fill: "#00B1A4"
});

function SvgClearCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearCircle);
export default __webpack_public_path__ + "static/media/clear_circle.cdd2fceb.svg";
export { ForwardRef as ReactComponent };